import React, { useContext, useEffect } from 'react';
import classNames from 'classnames';
import { Button } from 'reactstrap';
import ChartBase, { useChartBase } from './chart-base';
import SessionContext from 'SessionContext';

const AdHocLocationsWidget = (props) => {
  const base = useChartBase(props);
  const context = useContext(SessionContext);
  useEffect(() => {
    if (props.filters.length === 0) {
      context.crossfilterStore.remove_all_filters(props.config.id);
    }
    // eslint-disable-next-line
  }, [props.filters]);

  function getClassName() {
    return classNames('count-widget locations-widget location-filters');
  }

  function onRemoveEntry(ev, filter) {
    ev.preventDefault();
    const location = [filter.location];
    if (!props.filters?.length) { base.onFilterNegate(false); }
    context.crossfilterStore.remove_locations(location, true);
    props.onChartUpdate && props.onChartUpdate();
  }

  function renderSummary() {
    const filters = props.filters || [];
    return <>
      {!filters.length && <p>No Location Filters</p>}
      {filters.length &&
        <ul>
          {filters.map((filter) => (
            <li key={filter.location.id}>
              <span>{filter.value}mi around {filter?.location.name}</span>
            </li>
          ))}
        </ul>
      }
    </>;
  }

  function renderChart() {
    const filters = props.filters || [];
    return !filters.length ? (<p>No Location Filters</p>)
      : (
        <>
          {filters.map((filter) => (
            <div key={filter.location.id} className={`flex-row count-widget location-chart ${filters[0]?.is_negated ? 'is-negated' : ''}`}>
              <span onClick={() => {
                const lng = filter.location?.lng;
                const lat = filter.location?.lat;
                if (props.map && lng && lat) {
                  props.map.flyTo({ zoom: 12, center: [lng, lat], essential: true });
                } else {
                  base.setShowFlytoNotFound(true);
                }
              }}>
                <i className="fa-solid fa-crosshairs" />
                &nbsp;
              </span>
              <div
                id={filter.location.id}
                className={`value ${filter.is_negated ? 'selected not' : ''}`}>
                <label>{filter.location.name}</label>
                <i className='spacer' />
                <span className='radius count'>{filter.value} mi</span>
                <Button color="link" size="sm" className="remove" id={filter.location.id} onClick={(ev) => onRemoveEntry(ev, filter)}><i className="bi bi-trash"></i></Button>
              </div>
            </div>
          ))}
        </>
      );
  }

  return (
    <ChartBase
      {...props}
      base={base}
      chartClassName={getClassName()}
      renderSummary={renderSummary}
    >
      <div className={getClassName()}>
        {renderChart()}
      </div>
    </ChartBase>
  );
};

export default AdHocLocationsWidget;
